import { styled } from '@linaria/react';

export const PageIndicatorContainer = styled.div<{ active: boolean }>`
	width: ${({ active }) => (active ? '90px' : '6px')};
	height: 6px;
	border-radius: var(--radius-xxs);
	background-color: var(--color-white-xs);
	transition: width 0.3s ease;
`;

export const PageIndicatorActiveContent = styled.div`
	@keyframes progress {
		from {
			width: 0%;
		}
		to {
			width: 100%;
		}
	}
	width: 0;
	height: 100%;
	border-radius: var(--radius-xxs);
	animation: progress 3s ease-out forwards;

	background-color: var(--color-white-solid);
`;
